<template>
  <sui-page>
   <sui-page-header :title="wordHeaderName" :pageId="this.$options.name"></sui-page-header>
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_WRD_NM')"  :vertical="false" />
          </div>
          <div class="col-xs-5">
            <sui-text-field maxlength="100" placeholder="" v-model="wordName" name="wordName" @keyup.enter="searchWord"></sui-text-field>
          </div>
          <div class="btn_wrap">
          <sui-button type="button" class="comm_btn_Reset " @click= "onReset()">{{$t('MSG_BTN_RESET')}}</sui-button>
          <sui-button type="button" class="comm_btn_Scr" @click= "searchWord(wordName)" v-permission:read="this.$options.name" >{{$t('MSG_BTN_SEARCH')}}</sui-button>
        </div>
        </div>
        
      </div>
      <div class="mrT30"></div>
      <sui-grid ref="mainGrid"
      :columns="defaultGridData0.columns" :dataset="'dataset0'"
      :columnsautoresize="true"
      :autowidth="true"
      :columnsresize="true"
      :initialPagesize="10"
      :showDisplayCountControl="false"
      width="100%"
      @rowselect="onClickWordRow($event)"
      />
     <div class="comm_btn_wrap">
      <sui-button type="button" class="comm_btn_border"  @click="onCancel">{{$t('MSG_BTN_CANCEL')}}</sui-button>
      <sui-button type="button" class="comm_btn_solid" @click="onClickSelectWord">{{$t('MSG_BTN_SELT')}}</sui-button>
    </div>
  </sui-page-contents>

</sui-page>
</template>
<script>
 export default {
    name: 'PGE_CMT_00017',
    props: {
      closePagePopup: {
        type: Function,
      },
      pageInitialData: {
        type: Object,
      },
    },
    data() {
       return {
      nameTitle:'',
      wordName:'',
      selectedWord:'',
      choiceData : '',
      wordId : '',
      wordHeaderName:'Word Retrieval',
      localdata1:[],
        defaultGridData0: {
          dataSource: {
            localdata: [],
            emptyArray:[],
            datatype: 'json',
            editable: true,
            selectionmode: 'singlecell',
            editmode: 'click',
          },
          altrows: true,
          showcolumnlines: false,
          showcolumnheaderlines: false,
          columns: [{
            text: this.$t('MSG_TXT_WRD_NM'),
            datafield: 'wordName'
          }, {
            text: this.$t('MSG_TXT_WRD_EN_NM'),
            datafield: 'wordEnglishName'
          }, {
            text: this.$t('MSG_TXT_WRD_CNTN'),
            datafield: 'wordContent'
          }],
        }
       };
    },
    computed: {},
    watch: {},
   datasets: [{
      id: 'dataset0',
      type: 'local',
      data: 'localdata1',
      datafields: [ {
        name: 'wordName',
        type: 'string',
        map: 'wordName'
      }, {
        name: 'wordEnglishName',
        type: 'string',
        map: 'wordEnglishName'
      }, {
        name: 'wordContent',
        type: 'string',
        map: 'wordContent'
      }, {
        name: 'wordId',
        type: 'string',
        map: 'wordId'
      }]
    }],
    mounted() {
      console.log(this.$options.title)
    },
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
    methods: {
        searchWord() {
          if (utils.isExistSpecialChar(this.wordName) === true) {
            utils.messageBox(
              "warning",
              this.$t('MSG_ALT_PRHB_SPC_CHAR'),
              null
            );
            return;
          }
          let queryParams;
          let pageID = this.pageInitialData.content;
          this.nameTitle= this.pageInitialData.popTitle;
          //console.log(this.nameTitle);
          console.log(this.pageInitialData);
          //console.log(this.pageInitialData.popTitle);
          if(this.wordName){
              queryParams = { "word" : this.wordName };
          }
          http.request(pageID, 'DTS_CMT_00051', {
              query:queryParams
          }).then(res => {
              this.dataset0.setRawData(res.data);
          });
        },
        onReset() {
          this.wordName = '';
          this.wordId = '';
          let emptyArray=[];
           this.dataset0.setRawData(emptyArray)

        },
        onClickWordRow(e) {
          this.selectedWord = e.args.row.wordName;
          this.wordId = e.args.row.wordId;
          this.choiceData = e.args.row;
        },
         onClickSelectWord() {
           console.log(this.onPopupCancelClick);
           if(!this.selectedWord){
               utils.messageBox("information", this.$t('MSG_ALT_NO_DATA'), null, null);
           } else{
              this.closePagePopup(this.choiceData)
          }
       },
      onCancel(){
        console.log(this.onPopupCancelClick);
        this.onPopupCancelClick();
      },
      onPopupCancelClick() {
        this.closePagePopup();
      },
      // onCancel() {
      //   this.$emit('exit',true);
      //   console.log(this.$emit);
      // }
    },

  };
</script>
<style scoped>
</style>
